(() => {
  const product = document.querySelector('.kalie-pdp--minimal');
  const video = product?.querySelector('.kalie-gallery-video');
  const track = product?.querySelector('[data-jp-track]');
  if (!video || !track) return;
  const pauseIfHidden = () => {
    const frame = video.getBoundingClientRect();
    const gallery = track.getBoundingClientRect();
    if (frame.right <= gallery.left + 1 || frame.left >= gallery.right - 1 || frame.bottom <= 0 || frame.top >= innerHeight) video.pause();
  };
  track.addEventListener('scroll', pauseIfHidden, { passive: true });
  window.addEventListener('scroll', pauseIfHidden, { passive: true });
  document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); });
})();
